import React, { useState, useEffect, useRef } from 'react';
import { Box, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const VideoSplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Handle video end
    const handleVideoEnd = () => {
      console.log('🎬 Video splash completed');
      handleClose();
    };

    // Handle video error
    const handleVideoError = (e) => {
      console.error('❌ Video splash error:', e);
      // If video fails, close splash after 2 seconds
      setTimeout(handleClose, 2000);
    };

    video.addEventListener('ended', handleVideoEnd);
    video.addEventListener('error', handleVideoError);

    // Fallback: Auto-close after 12 seconds if video doesn't end
    const fallbackTimer = setTimeout(() => {
      console.log('⏰ Video splash fallback timeout');
      handleClose();
    }, 12000);

    return () => {
      video.removeEventListener('ended', handleVideoEnd);
      video.removeEventListener('error', handleVideoError);
      clearTimeout(fallbackTimer);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onComplete();
    }, 300); // Wait for fade out animation
  };

  const handleSkip = () => {
    console.log('⏭️ Video splash skipped by user');
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#0A2A66',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-out',
        overflow: 'hidden'
      }}
    >
      {/* Skip Button */}
      <IconButton
        onClick={handleSkip}
        sx={{
          position: 'absolute',
          top: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          zIndex: 10000,
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          },
          backdropFilter: 'blur(4px)',
        }}
        aria-label="Skip splash screen"
      >
        <CloseIcon />
      </IconButton>

      {/* Video */}
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          backgroundColor: '#0A2A66'
        }}
      >
        <source src="/Splash.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

    </Box>
  );
};

export default VideoSplashScreen;

